import { HttpResponse, http } from "msw";
import { apiPaths } from "../../api-paths.js";
import type { SessionAudit_V1_SaveSessionAuditRequest } from "../../swagger-types/v1/index.js";

export const sessionAuditHandlers = {
  postSessionAudit: [
    http.post(`**${apiPaths.sessionAudit.post}`, async () => {
      return HttpResponse.text("");
    }),
  ],
  postSessionAuditError: [
    http.post(`**${apiPaths.sessionAudit.post}`, async () => {
      return HttpResponse.error();
    }),
  ],
};

export const sessionAuditHandlersFactories = {
  postSessionAudit: (action: (data: SessionAudit_V1_SaveSessionAuditRequest) => Promise<void>) =>
    http.post(`**${apiPaths.sessionAudit.post}`, async ({ request }) => {
      await action((await request.json()) as SessionAudit_V1_SaveSessionAuditRequest);
      return HttpResponse.text("");
    }),
};
